/* ==========================================================================
   Mega menu desktop — pareggiamento altezza delle due colonne
   --------------------------------------------------------------------------
   Va in coppia con assets/header-megamenu-fix.css, che sistema scroll,
   posizione e separatore. Qui si risolve l'ultimo pezzo: far finire le due
   colonne alla stessa altezza.

   Perche' serve del codice e non basta il CSS: la colonna di sinistra (le
   voci di primo livello) e quella di destra (l'elenco che si apre) non sono
   elementi fratelli nel flusso — la seconda e' in position absolute dentro
   la prima. Nessuna regola CSS permette a un elemento di adattarsi
   all'altezza di un altro posizionato in modo assoluto, quindi l'altezza va
   misurata e applicata a mano.

   Cosa fa: quando il tema apre un sottomenu (aggiunge .is-visible), misura
   l'altezza naturale delle due colonne, prende la maggiore, la limita al
   massimo consentito dal CSS e la applica a entrambe. Alla chiusura
   ripristina tutto.

   Nota sul rinvio: si usa setTimeout e non requestAnimationFrame. I browser
   sospendono requestAnimationFrame quando la scheda non e' in primo piano,
   e in quel caso il ricalcolo non partirebbe.

   Sicurezza: se questo file non viene caricato o va in errore, il menu resta
   pienamente funzionante grazie ai ripieghi nel CSS. Le colonne finirebbero
   semplicemente ad altezze diverse quando l'elenco e' lungo.

   Solo da 990px in su: sotto quella soglia il menu e' il drawer mobile.
   ========================================================================== */

(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 990px)');
  var timer = null;

  /* Pulisce ogni altezza imposta in precedenza dentro un pannello: si azzera
     sempre tutto, non solo il sottomenu attualmente aperto, altrimenti
     resterebbero valori vecchi sugli elenchi chiusi. */
  function clear(dropdown, inner) {
    inner.style.minHeight = '';
    var subs = dropdown.querySelectorAll('.header__nav-sublinks');
    for (var j = 0; j < subs.length; j++) {
      subs[j].style.minHeight = '';
    }
  }

  function sync() {
    var inners = document.querySelectorAll(
      '.header__nav-item.dropdown .header__nav-dropdown-inner'
    );

    for (var i = 0; i < inners.length; i++) {
      var inner = inners[i];
      var dropdown = inner.closest('.header__nav-dropdown');
      if (!dropdown) {
        continue;
      }

      var open = dropdown.querySelector('.header__nav-sublinks.is-visible');

      /* Nessun sottomenu aperto, oppure siamo sotto la soglia desktop:
         si torna al comportamento del tema. */
      if (!mq.matches || !open) {
        clear(dropdown, inner);
        continue;
      }

      /* Azzerare prima di misurare e' indispensabile: altrimenti si
         leggerebbero le altezze imposte dalla sincronizzazione precedente e
         il pannello crescerebbe a ogni passaggio del mouse. */
      clear(dropdown, inner);
      open.style.minHeight = '0px';

      /* Il tetto e' gia' calcolato dal CSS in funzione dell'altezza della
         finestra: lo si rilegge invece di riscrivere la stessa formula qui. */
      var cap = parseFloat(window.getComputedStyle(open).maxHeight);
      if (isNaN(cap)) {
        cap = Infinity;
      }

      var target = Math.min(
        Math.max(inner.offsetHeight, open.offsetHeight),
        cap
      );

      inner.style.minHeight = target + 'px';
      open.style.minHeight = target + 'px';
    }
  }

  /* Le classi possono cambiare piu' volte durante una singola transizione:
     si accorpa tutto in un unico ricalcolo. */
  function schedule() {
    if (timer !== null) {
      return;
    }
    timer = window.setTimeout(function () {
      timer = null;
      sync();
    }, 0);
  }

  function start() {
    var scope = document.querySelector('.header__nav-items');
    if (!scope || !window.MutationObserver) {
      return;
    }

    /* Il tema apre e chiude i sottomenu aggiungendo e togliendo .is-visible.
       Si osserva solo l'attributo class: le altezze qui sopra si scrivono
       come stile inline, quindi non rilanciano l'osservatore. */
    new MutationObserver(schedule).observe(scope, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    /* Rete di sicurezza: il tema apre i sottomenu anche via CSS :hover, e su
       quel percorso non cambia alcuna classe. */
    scope.addEventListener('pointerover', schedule);
    scope.addEventListener('pointerleave', schedule);
    scope.addEventListener('focusin', schedule);

    window.addEventListener('resize', schedule);

    if (mq.addEventListener) {
      mq.addEventListener('change', schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
